import { render, staticRenderFns } from "./NoregExamination.vue?vue&type=template&id=29dad7ff"
import script from "./NoregExamination.vue?vue&type=script&lang=js"
export * from "./NoregExamination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports